import { Box, Typography } from "@mui/material";
import { DefaultUrlWeb } from "config/Configuration";

function WrapperValueBalance({ data }) {
  return (
    <Box display="flex" alignItems="center">
      <img
        width={"25px"}
        src={`${DefaultUrlWeb}${data?.imageUrl}`}
        alt={data?.name}
      />

      <Typography
        variant="h4"
        s
        color="text.main"
        fontWeight="600"
        marginLeft={1}
      >
        {" "}
        {data?.name}{" "}
      </Typography>
    </Box>
  );
}
export default WrapperValueBalance;
